const HEADER_OFFSET = 88;
const DURATION = 700;

function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

function animateScrollTo(targetY) {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    window.scrollTo(0, targetY);
    return;
  }

  const startY = window.scrollY;
  const distance = targetY - startY;
  const start = performance.now();

  function step(now) {
    const progress = Math.min((now - start) / DURATION, 1);
    window.scrollTo(0, startY + distance * easeInOutCubic(progress));
    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }

  requestAnimationFrame(step);
}

export function scrollToTop() {
  animateScrollTo(0);
}

export function scrollToSection(hash) {
  const el = document.querySelector(hash);
  if (!el) return;

  const targetY =
    el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
  animateScrollTo(Math.max(0, targetY));
  window.history.replaceState(null, "", hash);
}
